import { useUserCanEditBilling } from '../../hooks/useUserCanEditBilling';
import { EVENT_NAMES, EVENT_NAMESPACE } from './eventProperties';
import { BaseViewTracker } from './BaseViewTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const ComponentViewTracker = ({
  children,
  componentName,
  screen,
  threshold = 0.25,
  trackOnce = true,
  usageTracker
}) => {
  const userCanEditBilling = useUserCanEditBilling();
  const handleTrack = tracker => {
    tracker.track(EVENT_NAMESPACE, EVENT_NAMES.COMPONENT_VIEWED, {
      isBillingAdmin: userCanEditBilling,
      screen,
      component: componentName
    });
  };
  return /*#__PURE__*/_jsx(BaseViewTracker, {
    threshold: threshold,
    trackOnce: trackOnce,
    usageTracker: usageTracker,
    onTrack: handleTrack,
    children: children
  });
};